export type BasicRoaming = {
  calls: number
  texts: number
  data: number
}

export type DetailedRoaming = {
  data: number
  texts?: number
  make_calls: number
  receive_calls: number
  send_texts: number
  receive_texts: number
  calls?: number
  mms_uk: number
  mms_row: number
}

export type RoamingCharge = {
  name: string
  uri: string
  zone: string
  charges: BasicRoaming | DetailedRoaming
  roaming: string
  callingCodes: string[]
  special_note?: string
}

export const EU: BasicRoaming = {
  data: 10,
  calls: 25,
  texts: 10,
}

export const EEA: BasicRoaming = {
  data: 10,
  calls: 25,
  texts: 10,
}

export const ROW: DetailedRoaming = {
  data: 500,
  make_calls: 100,
  receive_calls: 100,
  send_texts: 30,
  receive_texts: -1,
  mms_uk: 30,
  mms_row: 24,
}

export const ZoneA: DetailedRoaming = {
  data: 20,
  make_calls: 100,
  receive_calls: 100,
  send_texts: 30,
  receive_texts: -1,
  mms_uk: 30,
  mms_row: 24,
}

export const ZoneB: DetailedRoaming = {
  data: 20,
  texts: 30,
  make_calls: 15,
  receive_calls: -1,
  receive_texts: -1,
  calls: 15,
  send_texts: 5,
  mms_uk: 30,
  mms_row: 24,
}

export const ZoneC: DetailedRoaming = {
  data: 2,
  make_calls: 9,
  receive_calls: 9,
  send_texts: 4,
  receive_texts: -1,
  mms_uk: 30,
  mms_row: 24,
}

export const RoamingZones = [
  {
    name: 'EU',
    uri: 'eu',
    zone: EU,
  },
  {
    name: 'EEA',
    uri: 'eea',
    zone: EEA,
  },
  {
    name: 'ROW',
    uri: 'row',
    zone: ROW,
  },
  {
    name: 'ZoneA',
    uri: 'zonea',
    zone: ZoneA,
  },
  {
    name: 'ZoneB',
    uri: 'zoneb',
    zone: ZoneB,
  },
  {
    name: 'ZoneC',
    uri: 'zonec',
    zone: ZoneC,
  },
]

const roamingCharges: RoamingCharge[] = [
  {
    name: 'Ascension Island',
    uri: 'ascension_island',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['247'],
  },
  {
    name: 'Abkhazia',
    uri: 'abkhazia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['7840'],
  },
  {
    name: 'Afghanistan',
    uri: 'afghanistan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['93'],
  },
  {
    name: 'Alaska',
    uri: 'alaska',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['1'],
  },
  {
    name: 'Albania',
    uri: 'albania',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['355'],
  },
  {
    name: 'Algeria',
    uri: 'algeria',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['213'],
  },
  {
    name: 'American Samoa',
    uri: 'american_samoa',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['1'],
  },
  {
    name: 'Andorra',
    uri: 'andorra',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['376'],
  },
  {
    name: 'Angola',
    uri: 'angola',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['244'],
  },
  {
    name: 'Anguilla',
    uri: 'anguilla',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1264'],
  },
  {
    name: 'Antigua',
    uri: 'antigua',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1268'],
  },
  {
    name: 'Argentina',
    uri: 'argentina',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['54'],
  },
  {
    name: 'Armenia',
    uri: 'armenia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['374'],
  },
  {
    name: 'Aruba',
    uri: 'aruba',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['297'],
  },
  {
    name: 'Australia',
    uri: 'australia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['61'],
  },
  {
    name: 'Austria',
    uri: 'austria',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['43'],
  },
  {
    name: 'Azerbaijan',
    uri: 'azerbaijan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['994'],
  },
  {
    name: 'Bahamas',
    uri: 'bahamas',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1242'],
  },
  {
    name: 'Bahrain',
    uri: 'bahrain',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['973'],
  },
  {
    name: 'Bangladesh',
    uri: 'bangladesh',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['880'],
  },
  {
    name: 'Barbados',
    uri: 'barbados',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['1246'],
  },
  {
    name: 'Belarus',
    uri: 'belarus',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['375'],
  },
  {
    name: 'Belgium',
    uri: 'belgium',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['32'],
  },
  {
    name: 'Belize',
    uri: 'belize',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['501'],
  },
  {
    name: 'Benin',
    uri: 'benin',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['229'],
  },
  {
    name: 'Bermuda',
    uri: 'bermuda',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1441'],
  },
  {
    name: 'Bhutan',
    uri: 'bhutan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['975'],
  },
  {
    name: 'Bolivia',
    uri: 'bolivia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['591'],
  },
  {
    name: 'Bosnia & Herzegovina',
    uri: 'bosnia_&_herzegovina',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['387'],
  },
  {
    name: 'Botswana',
    uri: 'botswana',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['267'],
  },
  {
    name: 'Brazil',
    uri: 'brazil',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['55'],
  },
  {
    name: 'British Virgin Islands',
    uri: 'british_virgin_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1284'],
  },
  {
    name: 'Brunei',
    uri: 'brunei',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['673'],
  },
  {
    name: 'Bulgaria',
    uri: 'bulgaria',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['359'],
  },
  {
    name: 'Burkina Faso',
    uri: 'burkina_faso',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['226'],
  },
  {
    name: 'Burundi',
    uri: 'burundi',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['257'],
  },
  {
    name: 'Cambodia',
    uri: 'cambodia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['855'],
  },
  {
    name: 'Cameroon',
    uri: 'cameroon',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['237'],
  },
  {
    name: 'Canada',
    uri: 'canada',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['1'],
  },
  {
    name: 'Cape Verde',
    uri: 'cape_verde',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['238'],
  },
  {
    name: 'Cayman Islands',
    uri: 'cayman_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1345'],
  },
  {
    name: 'Central African Republic',
    uri: 'central_african_republic',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['236'],
  },
  {
    name: 'Chad',
    uri: 'chad',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['235'],
  },
  {
    name: 'Chile',
    uri: 'chile',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['56'],
  },
  {
    name: 'China',
    uri: 'china',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['86'],
  },
  {
    name: 'Colombia',
    uri: 'colombia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['57'],
  },
  {
    name: 'Comoros',
    uri: 'comoros',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['269'],
  },
  {
    name: 'Congo',
    uri: 'congo',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['242'],
  },
  {
    name: 'Congo Dm Rep',
    uri: 'congo_dm_rep',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['243'],
  },
  {
    name: 'Cook Islands',
    uri: 'cook_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['682'],
  },
  {
    name: 'Costa Rica',
    uri: 'costa_rica',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['506'],
  },
  {
    name: 'Croatia',
    uri: 'croatia',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['385'],
  },
  {
    name: 'Cuba',
    uri: 'cuba',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['53'],
  },
  {
    name: 'Cyprus',
    uri: 'cyprus',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    special_note: 'Please note that in Northern parts of Cyprus, Turkish rates apply.',
    callingCodes: ['357'],
  },
  {
    name: 'Czech Republic',
    uri: 'czech_republic',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['420'],
  },
  {
    name: 'Denmark',
    uri: 'denmark',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['45'],
  },
  {
    name: 'Diego Garcia',
    uri: 'diego_garcia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['246'],
  },
  {
    name: 'Djibouti',
    uri: 'djibouti',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['253'],
  },
  {
    name: 'Dominica',
    uri: 'dominica',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1767'],
  },
  {
    name: 'Dominican Republic',
    uri: 'dominican_republic',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['1809'],
  },
  {
    name: 'Timor-Leste (East Timor)',
    uri: 'timor-leste_east_timor',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['670'],
  },
  {
    name: 'Ecuador',
    uri: 'ecuador',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['593'],
  },
  {
    name: 'Egypt',
    uri: 'egypt',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['20'],
  },
  {
    name: 'Equatorial Guinea',
    uri: 'equatorial_guinea',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['240'],
  },
  {
    name: 'Eritrea',
    uri: 'eritrea',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['291'],
  },
  {
    name: 'Estonia',
    uri: 'estonia',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['372'],
  },
  {
    name: 'Ethiopia',
    uri: 'ethiopia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['251'],
  },
  {
    name: 'Faeroe Islands',
    uri: 'faeroe_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['298'],
  },
  {
    name: 'Falkland Islands',
    uri: 'falkland_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['500'],
  },
  {
    name: 'Fiji',
    uri: 'fiji',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['679'],
  },
  {
    name: 'Finland',
    uri: 'finland',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['358'],
  },
  {
    name: 'France',
    uri: 'france',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['33'],
  },
  {
    name: 'French Guiana',
    uri: 'french_guiana',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['594'],
  },
  {
    name: 'French Polynesia',
    uri: 'french_polynesia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['689'],
  },
  {
    name: 'French Southern and Antarctic Lands',
    uri: 'french_southern_and_antarctic_lands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['262'],
  },
  {
    name: 'Gabon',
    uri: 'gabon',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['241'],
  },
  {
    name: 'Gambia',
    uri: 'gambia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['220'],
  },
  {
    name: 'Georgia',
    uri: 'georgia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['995'],
  },
  {
    name: 'Germany',
    uri: 'germany',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['49'],
  },
  {
    name: 'Ghana',
    uri: 'ghana',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['233'],
  },
  {
    name: 'Gibraltar',
    uri: 'gibraltar',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['350'],
  },
  {
    name: 'Greece',
    uri: 'greece',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['30'],
  },
  {
    name: 'Greenland',
    uri: 'greenland',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['299'],
  },
  {
    name: 'Grenada',
    uri: 'grenada',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1473'],
  },
  {
    name: 'Guadeloupe',
    uri: 'guadeloupe',
    zone: 'EU',
    charges: EU,
    roaming: 'partial',
    callingCodes: ['590'],
  },
  {
    name: 'Guam',
    uri: 'guam',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['1671'],
  },
  {
    name: 'Guatemala',
    uri: 'guatemala',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['502'],
  },
  {
    name: 'Guernsey',
    uri: 'guernsey',
    zone: 'ZoneB',
    charges: ZoneB,
    roaming: 'yes',
    callingCodes: ['44'],
  },
  {
    name: 'Guinea',
    uri: 'guinea',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['224'],
  },
  {
    name: 'Guinee Bissau',
    uri: 'guinee_bissau',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['245'],
  },
  {
    name: 'Guyana',
    uri: 'guyana',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['592'],
  },
  {
    name: 'Haiti',
    uri: 'haiti',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['509'],
  },
  {
    name: 'Honduras',
    uri: 'honduras',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['504'],
  },
  {
    name: 'Hong Kong',
    uri: 'hong_kong',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['852'],
  },
  {
    name: 'Hungary',
    uri: 'hungary',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['36'],
  },
  {
    name: 'Iceland',
    uri: 'iceland',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['354'],
  },
  {
    name: 'India',
    uri: 'india',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['91'],
  },
  {
    name: 'Indonesia',
    uri: 'indonesia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['62'],
  },
  {
    name: 'Iran',
    uri: 'iran',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['98'],
  },
  {
    name: 'Iraq',
    uri: 'iraq',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['964'],
  },
  {
    name: 'Ireland',
    uri: 'ireland',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['353'],
  },
  {
    name: 'Isle of Man',
    uri: 'isle_of_man',
    zone: 'ZoneB',
    charges: ZoneB,
    roaming: 'yes',
    callingCodes: ['44'],
  },
  {
    name: 'Israel',
    uri: 'israel',
    zone: 'ZoneC',
    charges: ZoneC,
    roaming: 'yes',
    callingCodes: ['972'],
  },
  {
    name: 'Italy',
    uri: 'italy',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['39'],
  },
  {
    name: 'Ivory Coast',
    uri: 'ivory_coast',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['225'],
  },
  {
    name: 'Jamaica',
    uri: 'jamaica',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['1876'],
  },
  {
    name: 'Japan',
    uri: 'japan',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['81'],
  },
  {
    name: 'Jersey',
    uri: 'jersey',
    zone: 'ZoneB',
    charges: ZoneB,
    roaming: 'yes',
    callingCodes: ['44'],
  },
  {
    name: 'Jordan',
    uri: 'jordan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['962'],
  },
  {
    name: 'Kazakhstan',
    uri: 'kazakhstan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['7'],
  },
  {
    name: 'Kenya',
    uri: 'kenya',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['254'],
  },
  {
    name: 'Kiribati',
    uri: 'kiribati',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['686'],
  },
  {
    name: 'Korea North',
    uri: 'korea_north',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['850'],
  },
  {
    name: 'Korea South',
    uri: 'korea_south',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['82'],
  },
  {
    name: 'Kuwait',
    uri: 'kuwait',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['965'],
  },
  {
    name: 'Kyrgyzstan',
    uri: 'kyrgyzstan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['996'],
  },
  {
    name: 'Laos',
    uri: 'laos',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['856'],
  },
  {
    name: 'Latvia',
    uri: 'latvia',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['371'],
  },
  {
    name: 'Lebanon',
    uri: 'lebanon',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['961'],
  },
  {
    name: 'Lesotho',
    uri: 'lesotho',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['266'],
  },
  {
    name: 'Liberia',
    uri: 'liberia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['231'],
  },
  {
    name: 'Libya',
    uri: 'libya',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['218'],
  },
  {
    name: 'Liechtenstein',
    uri: 'liechtenstein',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['423'],
  },
  {
    name: 'Lithuania',
    uri: 'lithuania',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['370'],
  },
  {
    name: 'Luxembourg',
    uri: 'luxembourg',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['352'],
  },
  {
    name: 'Macau',
    uri: 'macau',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['853'],
  },
  {
    name: 'Macedonia',
    uri: 'macedonia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['389'],
  },
  {
    name: 'Madagascar',
    uri: 'madagascar',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['261'],
  },
  {
    name: 'Malawi',
    uri: 'malawi',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['265'],
  },
  {
    name: 'Malaysia',
    uri: 'malaysia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['60'],
  },
  {
    name: 'Maldives',
    uri: 'maldives',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['960'],
  },
  {
    name: 'Mali',
    uri: 'mali',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['223'],
  },
  {
    name: 'Malta',
    uri: 'malta',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['356'],
  },
  {
    name: 'Iles-Mariannes',
    uri: 'iles-mariannes',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['1670'],
  },
  {
    name: 'Marshall Islands',
    uri: 'marshall_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['692'],
  },
  {
    name: 'Martinique',
    uri: 'martinique',
    zone: 'EU',
    charges: EU,
    roaming: 'partial',
    callingCodes: ['596'],
  },
  {
    name: 'Mauritania',
    uri: 'mauritania',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['222'],
  },
  {
    name: 'Mauritius',
    uri: 'mauritius',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['230'],
  },
  {
    name: 'Mayotte',
    uri: 'mayotte',
    zone: 'EEA',
    charges: EEA,
    roaming: 'partial',
    callingCodes: ['262'],
  },
  {
    name: 'Mexico',
    uri: 'mexico',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['52'],
  },
  {
    name: 'Micronesia',
    uri: 'micronesia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['691'],
  },
  {
    name: 'Moldova',
    uri: 'moldova',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['373'],
  },
  {
    name: 'Monaco',
    uri: 'monaco',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['377'],
  },
  {
    name: 'Mongolia',
    uri: 'mongolia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['976'],
  },
  {
    name: 'Montenegro',
    uri: 'montenegro',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['382'],
  },
  {
    name: 'Montserrat',
    uri: 'montserrat',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1664'],
  },
  {
    name: 'Morocco',
    uri: 'morocco',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['212'],
  },
  {
    name: 'Mozambique',
    uri: 'mozambique',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['258'],
  },
  {
    name: 'Myanmar',
    uri: 'myanmar',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['95'],
  },
  {
    name: 'Namibia',
    uri: 'namibia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['264'],
  },
  {
    name: 'Nauru',
    uri: 'nauru',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['674'],
  },
  {
    name: 'Nepal',
    uri: 'nepal',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['977'],
  },
  {
    name: 'Netherland Antilles',
    uri: 'netherland_antilles',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['599'],
  },
  {
    name: 'Netherlands',
    uri: 'netherlands',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['31'],
  },
  {
    name: 'New Caledonia',
    uri: 'new_caledonia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['687'],
  },
  {
    name: 'New Zealand',
    uri: 'new_zealand',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['64'],
  },
  {
    name: 'Nicaragua',
    uri: 'nicaragua',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['505'],
  },
  {
    name: 'Niger',
    uri: 'niger',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['227'],
  },
  {
    name: 'Nigeria',
    uri: 'nigeria',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['234'],
  },
  {
    name: 'Niue',
    uri: 'niue',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['683'],
  },
  {
    name: 'Norfolk Islands',
    uri: 'norfolk_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['672'],
  },
  {
    name: 'Norway',
    uri: 'norway',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['47'],
  },
  {
    name: 'Oman',
    uri: 'oman',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['968'],
  },
  {
    name: 'Pakistan',
    uri: 'pakistan',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['92'],
  },
  {
    name: 'Palau',
    uri: 'palau',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['680'],
  },
  {
    name: 'Palestine',
    uri: 'palestine',
    zone: 'ZoneC',
    charges: ZoneC,
    roaming: 'partial',
    callingCodes: ['970'],
  },
  {
    name: 'Panama',
    uri: 'panama',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['507'],
  },
  {
    name: 'Papua New Guinea',
    uri: 'papua_new_guinea',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['675'],
  },
  {
    name: 'Paraguay',
    uri: 'paraguay',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['595'],
  },
  {
    name: 'Peru',
    uri: 'peru',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['51'],
  },
  {
    name: 'Philippines',
    uri: 'philippines',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['63'],
  },
  {
    name: 'Poland',
    uri: 'poland',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['48'],
  },
  {
    name: 'Portugal',
    uri: 'portugal',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['351'],
  },
  {
    name: 'Puerto Rico',
    uri: 'puerto_rico',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['1787', '1939'],
  },
  {
    name: 'Qatar',
    uri: 'qatar',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['974'],
  },
  {
    name: 'Reunion',
    uri: 'reunion',
    zone: 'EU',
    charges: EU,
    roaming: 'partial',
    callingCodes: ['262'],
  },
  {
    name: 'Romania',
    uri: 'romania',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['40'],
  },
  {
    name: 'Russia',
    uri: 'russia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['7'],
  },
  {
    name: 'Rwanda',
    uri: 'rwanda',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['250'],
  },
  {
    name: 'El Salvador',
    uri: 'el_salvador',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['503'],
  },
  {
    name: 'San Marino',
    uri: 'san_marino',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['378'],
  },
  {
    name: 'Sint Maarten',
    uri: 'sint_maarten',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['1721'],
  },
  {
    name: 'Sao Tome and Principe',
    uri: 'sao_tome_and_principe',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['239'],
  },
  {
    name: 'Saudi Arabia',
    uri: 'saudi_arabia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['966'],
  },
  {
    name: 'Senegal',
    uri: 'senegal',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['221'],
  },
  {
    name: 'Serbia',
    uri: 'serbia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['381'],
  },
  {
    name: 'Seychelles',
    uri: 'seychelles',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['248'],
  },
  {
    name: 'Sierra Leone',
    uri: 'sierra_leone',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['232'],
  },
  {
    name: 'Singapore',
    uri: 'singapore',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['65'],
  },
  {
    name: 'Slovakia',
    uri: 'slovakia',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['421'],
  },
  {
    name: 'Slovenia',
    uri: 'slovenia',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['386'],
  },
  {
    name: 'Solomon Islands',
    uri: 'solomon_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['677'],
  },
  {
    name: 'Somalia',
    uri: 'somalia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['252'],
  },
  {
    name: 'South Africa',
    uri: 'south_africa',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['27'],
  },
  {
    name: 'South Sudan',
    uri: 'south_sudan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['211'],
  },
  {
    name: 'Spain',
    uri: 'spain',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['34'],
  },
  {
    name: 'Sri Lanka',
    uri: 'sri_lanka',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['94'],
  },
  {
    name: 'St Helena',
    uri: 'st_helena',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['290'],
  },
  {
    name: 'St Kitts & Nevis',
    uri: 'st_kitts_&_nevis',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1869'],
  },
  {
    name: 'St Lucia',
    uri: 'st_lucia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1758'],
  },
  {
    name: 'St Pierre & Miquelon',
    uri: 'st_pierre_&_miquelon',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['508'],
  },
  {
    name: 'St Vincent & The Grenadines',
    uri: 'st_vincent_&_the_grenadines',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1784'],
  },
  {
    name: 'Sudan',
    uri: 'sudan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['249'],
  },
  {
    name: 'Surinam',
    uri: 'surinam',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['597'],
  },
  {
    name: 'Swaziland',
    uri: 'swaziland',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['268'],
  },
  {
    name: 'Sweden',
    uri: 'sweden',
    zone: 'EU',
    charges: EU,
    roaming: 'yes',
    callingCodes: ['46'],
  },
  {
    name: 'Switzerland',
    uri: 'switzerland',
    zone: 'ZoneB',
    charges: ZoneB,
    roaming: 'yes',
    callingCodes: ['41'],
  },
  {
    name: 'Syria',
    uri: 'syria',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['963'],
  },
  {
    name: 'Tajikistan',
    uri: 'tajikistan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['992'],
  },
  {
    name: 'Taiwan',
    uri: 'taiwan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['886'],
  },
  {
    name: 'Tanzania',
    uri: 'tanzania',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['255'],
  },
  {
    name: 'Thailand',
    uri: 'thailand',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['66'],
  },
  {
    name: 'Togo',
    uri: 'togo',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['228'],
  },
  {
    name: 'Tokelau',
    uri: 'tokelau',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['690'],
  },
  {
    name: 'Tonga',
    uri: 'tonga',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['676'],
  },
  {
    name: 'Trinidad and Tobago',
    uri: 'trinidad_and_tobago',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1868'],
  },
  {
    name: 'Tunisia',
    uri: 'tunisia',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['216'],
  },
  {
    name: 'Türkiye (Turkey)',
    uri: 'türkiye',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['90'],
  },
  {
    name: 'Turkmenistan',
    uri: 'turkmenistan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['993'],
  },
  {
    name: 'Turks and Caicos',
    uri: 'turks_and_caicos',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['1649'],
  },
  {
    name: 'Tuvalu',
    uri: 'tuvalu',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['688'],
  },
  {
    name: 'Uganda',
    uri: 'uganda',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['256'],
  },
  {
    name: 'Ukraine',
    uri: 'ukraine',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['380'],
  },
  {
    name: 'United Arab Emirates',
    uri: 'united_arab_emirates',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    callingCodes: ['971'],
  },
  {
    name: 'Uruguay',
    uri: 'uruguay',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['598'],
  },
  {
    name: 'US Virgin Islands',
    uri: 'us_virgin_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['1340'],
  },
  {
    name: 'USA (excl. Alaska and Hawaii)',
    uri: 'usa_excl_alaska_and_hawaii',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'yes',
    special_note: 'Please note that these prices do not apply to Alaska and Hawaii.',
    callingCodes: ['1'],
  },
  {
    name: 'Uzbekistan',
    uri: 'uzbekistan',
    zone: 'ROW',
    charges: ROW,
    roaming: 'yes',
    callingCodes: ['998'],
  },
  {
    name: 'Vanuatu',
    uri: 'vanuatu',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['678'],
  },
  {
    name: 'Venezuela',
    uri: 'venezuela',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['58'],
  },
  {
    name: 'Vietnam',
    uri: 'vietnam',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['84'],
  },
  {
    name: 'Wallis and Futuna Islands',
    uri: 'wallis_and_futuna_islands',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['681'],
  },
  {
    name: 'Western Sahara',
    uri: 'western_sahara',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['212'],
  },
  {
    name: 'Western Samoa',
    uri: 'western_samoa',
    zone: 'ROW',
    charges: ROW,
    roaming: 'no',
    callingCodes: ['685'],
  },
  {
    name: 'Yemen',
    uri: 'yemen',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['967'],
  },
  {
    name: 'Zambia',
    uri: 'zambia',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['260'],
  },
  {
    name: 'Zimbabwe',
    uri: 'zimbabwe',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['263'],
  },
  {
    name: 'Hawaii',
    uri: 'hawaii',
    zone: 'ZoneA',
    charges: ZoneA,
    roaming: 'partial',
    callingCodes: ['1'],
  },
  {
    name: 'Kosovo',
    uri: 'kosovo',
    zone: 'ROW',
    charges: ROW,
    roaming: 'partial',
    callingCodes: ['383'],
  },
]

export default roamingCharges
